import { Component, EventEmitter, Input, NgZone, OnInit, OnChanges, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { OrderService } from '../../services/order.service';
import {
    TagMap
    , SearchTagMap
    , SearchTagType
} from '../../models/models';

@Component({
    selector: 'tagmap-select',
    templateUrl: './tagmap-select.component.html',
    standalone: false
})
export class TagMapSelect implements OnInit, OnChanges {
    @Input() recordID: number = 0;
    @Input() recordTypeName: string = "";
    @Input() readonly: boolean = false;
    @Output() onRefresh = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public tagMapGrid!: GridComponent;

    public isLoading: boolean = false;

    //public selectedCarrierReps: Employee[] = [];
    public tagTypeList: SearchTagType[] = [];
    public tagMapList: SearchTagMap[] = [];
    public tagMapListState: State = { sort: [{ dir: 'asc', field: 'tagTypeName' }] };
    public tagMapListView: GridDataResult = { data: [], total: 0 };

    constructor(private ngZone: NgZone, private orderService: OrderService) {
    }

    ngOnInit() {
        this.tagTypeList.length = 0;
        this.tagMapList.length = 0;
        //console.log("ngOnInit", this.recordID, this.recordTypeName, this.tagTypeList, this.tagMapList);
    }

    ngOnChanges() {
        this.getSearchTagType();
    }

    private getTagMapByQuoteOrderID() {
        this.orderService.getSearchTagMapByQuoteOrderID(this.recordID).subscribe(result => {
            this.tagMapList = result.resultCollection;
            this.setupTagMapList();
        });
    }

    private getTagMapByQuoteOrderLineID() {
        this.orderService.getSearchTagMapByQuoteOrderLineID(this.recordID).subscribe(result => {
            this.tagMapList = result.resultCollection;
            this.setupTagMapList();
        });
    }

    private getTagMapByCustomerID() {
        this.orderService.getSearchTagMapByCustomerID(this.recordID).subscribe(result => {
            this.tagMapList = result.resultCollection;
            this.setupTagMapList();
        });
    }

    private getSearchTagType() {
        this.orderService.getSearchTagTypeByRecordTypeName(this.recordTypeName).subscribe(result => {
            this.tagTypeList = result.resultCollection;

            if (this.recordTypeName == "QuoteOrder") {
                this.getTagMapByQuoteOrderID();
            }
            else if (this.recordTypeName == "QuoteOrderLine") {
                this.getTagMapByQuoteOrderLineID();
            }
            else if (this.recordTypeName == "Customer") {
                this.getTagMapByCustomerID();
            }
        });
    }

    private setupTagMapList() {
        for (var i = 0; i < this.tagTypeList.length; i++) {
            var idx: number = this.tagMapList.findIndex(t => t.tagTypeID == this.tagTypeList[i].tagTypeID);
            if (idx < 0) {
                var searchTagMap: SearchTagMap = {
                    viewid: "",
                    tagMapID: 0,
                    tagNote: "",
                    tagTypeID: this.tagTypeList[i].tagTypeID,
                    tagTypePrefix: this.tagTypeList[i].tagTypePrefix,
                    tagTypeName: this.tagTypeList[i].tagTypeName,
                    tagTypeDescription: this.tagTypeList[i].tagTypeDescription,
                    colorClassName: this.tagTypeList[i].colorClassName,
                    isTrackingVisible: this.tagTypeList[i].isTrackingVisible,
                    isTagTypeActive: this.tagTypeList[i].isActive,
                    recordID: 0,
                    recordTypeID: this.tagTypeList[i].recordTypeID,
                    recordTypeName: this.tagTypeList[i].recordTypeName
                };
                this.tagMapList.push(searchTagMap);
            }
        }
        this.tagMapList = this.tagMapList.sort((left, right): number => {
            if (left.tagTypeName < right.tagTypeName) return -1;
            if (left.tagTypeName > right.tagTypeName) return 1;
            return 0;
        });
        this.tagMapListView = process(this.tagMapList, this.tagMapListState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.tagMapGrid == null) return;
            this.tagMapGrid.autoFitColumns();
        });
    }

    public tagMapListStateChange(state: DataStateChangeEvent): void {
        this.tagMapListState = state;
        //console.log("tagMapListStateChange", this.tagMapList);
        this.tagMapListView = process(this.tagMapList, this.tagMapListState);
    }

    public setTag(tagMap: SearchTagMap) {
        if (tagMap.recordID > 0) {
            //rep.quoteOrderLineID = 0;
            //tagMap.recordID = 0;
            this.deleteTagMap(tagMap);
        }
        else {
            tagMap.recordID = this.recordID;
            this.saveTagMap(tagMap);
        }
        //console.log("setTagMap", tagMap, this.tagMapList);
    }

    public setTagNote(tagMap: SearchTagMap) {
        if (tagMap.tagMapID > 0) {
            this.saveTagMap(tagMap);
        }
        //console.log("setTagNote", tagMap, this.tagMapList);
    }

    public deleteTagMap(tagMap: SearchTagMap) {
        this.isLoading = true;
        this.orderService.deleteTagMapByID(tagMap.tagMapID).subscribe(result => {
            this.isLoading = false;
            var idx = this.tagMapList.findIndex(c => c.tagMapID == tagMap.tagMapID);
            this.tagMapList[idx].viewid = "";
            this.tagMapList[idx].tagMapID = 0;
            this.tagMapList[idx].recordID = 0;
            this.tagMapList[idx].tagNote = "";
            this.tagMapListView = process(this.tagMapList, this.tagMapListState);
            this.onRefresh.emit();
            //console.log("deleteTagMap", this.tagMapList, tagMap);
        });
    }

    public saveTagMap(tagMap: SearchTagMap) {
        this.isLoading = true;
        var saveTagMap: TagMap = {
            tagMapID: tagMap.tagMapID,
            tagTypeID: tagMap.tagTypeID,
            recordID: tagMap.recordID,
            recordTypeID: tagMap.recordTypeID,
            tagNote: tagMap.tagNote,
            createdByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
            createdDate: new Date()
        };
        this.orderService.saveTagMap(saveTagMap).subscribe(result => {
            this.isLoading = false;
            var updatedTagMap: TagMap = result.resultCollection[0];
            var idx = this.tagMapList.findIndex(c => c.tagTypeID == tagMap.tagTypeID);
            this.tagMapList[idx].viewid = "";
            this.tagMapList[idx].tagMapID = updatedTagMap.tagMapID;
            this.tagMapList[idx].recordID = updatedTagMap.recordID;
            this.tagMapList[idx].tagNote = updatedTagMap.tagNote;
            this.tagMapListView = process(this.tagMapList, this.tagMapListState);
            //rep.tagMapID = saveRep.tagMapID;
            //rep.quoteOrderLineID = saveRep.quoteOrderLineID;
            this.onRefresh.emit();
            //console.log("saveTagMap", this.tagMapList, tagMap);
        });
    }
}
